import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
    MdNotifications,
    MdCheckCircle,
    MdInfo,
    MdStar,
    MdCardGiftcard,
    MdCancel,
    MdKeyboardArrowLeft,
    MdKeyboardArrowRight
} from 'react-icons/md';

import { appointmentsAPI } from 'services/api';

// --- FONKSİYONLAR (WORK-LOGIC BİREBİR KORUNDU) ---
const createSafeDate = (dateStr, timeStr) => {
    try {
        const pureDateStr = dateStr.split('T')[0];
        const dateParts = pureDateStr.split('-');
        const timeParts = timeStr.split(':');
        return new Date(
            parseInt(dateParts[0]),
            parseInt(dateParts[1]) - 1,
            parseInt(dateParts[2]),
            parseInt(timeParts[0]),
            parseInt(timeParts[1]),
            parseInt(timeParts[2] || 0),
        );
    } catch (e) {
        console.error('createSafeDate hatası:', dateStr, timeStr, e);
        return null;
    }
};

const createSafeUpdateDate = (dateStr) => {
    try {
        if (!dateStr) return new Date();
        return new Date(dateStr.replace(' ', 'T'));
    } catch (e) {
        console.error('createSafeUpdateDate hatası:', dateStr, e);
        return new Date();
    }
};
// --- FONKSİYONLAR SONU ---

const PAGE_SIZE = 10;

// --- SKELETON LOADER ---
const NotificationsSkeleton = () => (
    <div className="flex flex-col gap-4 animate-pulse">
        {[...Array(6)].map((_, i) => (
            <div key={i} className="flex items-center gap-4 p-4 rounded-2xl bg-gray-100 dark:bg-navy-900/50" />
        ))}
    </div>
);

const CustomerNotifications = () => {
    // --- STATELER ---
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);

    // --- API VERİ ÇEKME & İŞLEME (BİREBİR KORUNDU) ---
    useEffect(() => {
        const fetchAndGenerateNotifications = async () => {
            setLoading(true);
            try {
                const response = await appointmentsAPI.getMyAppointments();
                const appointments = response.appointments || [];
                const generatedNotifications = [];

                const today = new Date(); today.setHours(0, 0, 0, 0);
                const tomorrow = new Date(today); tomorrow.setDate(today.getDate() + 1);

                const dateFormatter = new Intl.DateTimeFormat('tr-TR', { year: 'numeric', month: 'long', day: 'numeric' });
                const timeFormatter = new Intl.DateTimeFormat('tr-TR', { hour: '2-digit', minute: '2-digit' });

                const isDateMatching = (dateStr, timeStr, targetDate) => {
                    const appDate = createSafeDate(dateStr, timeStr);
                    if (!appDate) return false;
                    appDate.setHours(0, 0, 0, 0);
                    return appDate.getTime() === targetDate.getTime();
                };

                for (const app of appointments) {
                    if (!app.service || !app.staff) continue;

                    const appDateTime = createSafeDate(app.appointment_date, app.appointment_time);
                    if (!appDateTime) continue;

                    const isTomorrow = isDateMatching(app.appointment_date, app.appointment_time, tomorrow);
                    const isToday = isDateMatching(app.appointment_date, app.appointment_time, today);
                    const safeUpdatedAt = createSafeUpdateDate(app.updated_at);
                    const updatedAtDateStr = dateFormatter.format(safeUpdatedAt);

                    // Tip 1: Değerlendirme
                    if (app.status === 'completed' && !app.rating) {
                        generatedNotifications.push({ id: `review-${app.id}`, type: 'review', text: `${app.service.name} hizmetinizi değerlendirin.`, date: updatedAtDateStr, link: `/customer/appointments`, sortDate: safeUpdatedAt });
                    }
                    // Tip 2: Hatırlatma
                    if (app.status === 'approved' && isTomorrow) {
                        generatedNotifications.push({ id: `reminder-${app.id}`, type: 'info', text: `Yarın saat ${app.appointment_time.substring(0, 5)} için ${app.service.name} randevunuzu unutmayın.`, date: null, sortDate: new Date() });
                    }
                    // Tip 3: Onay
                    if (app.status === 'approved' && appDateTime > new Date()) {
                        if (isToday) {
                            generatedNotifications.push({ id: `approved-today-${app.id}`, type: 'success', text: `Bugün saat ${app.appointment_time.substring(0, 5)} için ${app.service.name} randevunuz onaylandı.`, date: updatedAtDateStr, sortDate: safeUpdatedAt });
                        } else if (!isTomorrow) {
                            generatedNotifications.push({ id: `approved-${app.id}`, type: 'success', text: `${dateFormatter.format(appDateTime)} ${timeFormatter.format(appDateTime)} tarihli ${app.service.name} randevunuz onaylandı.`, date: updatedAtDateStr, sortDate: safeUpdatedAt });
                        }
                    }
                    // Tip 4: İptal
                    if (app.status === 'cancelled') {
                        generatedNotifications.push({ id: `cancelled-${app.id}`, type: 'danger', text: `${dateFormatter.format(appDateTime)} tarihli randevunuz iptal edildi.`, date: updatedAtDateStr, sortDate: safeUpdatedAt });
                    }
                }

                generatedNotifications.sort((a, b) => b.sortDate - a.sortDate);
                setNotifications(generatedNotifications);
            } catch (error) {
                console.error('Bildirimler getirilirken hata:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchAndGenerateNotifications();
    }, []);

    // --- İKON & RENK ÇÖZÜCÜ (HORIZONUI STANDARDINA GÖRE) ---
    const getNotificationIcon = (type) => {
        switch (type) {
            case 'success': return { icon: <MdCheckCircle />, colorClass: 'text-green-500', bgClass: 'bg-green-50 dark:bg-green-500/10' };
            case 'info': return { icon: <MdInfo />, colorClass: 'text-blue-500', bgClass: 'bg-blue-50 dark:bg-blue-500/10' };
            case 'review': return { icon: <MdStar />, colorClass: 'text-amber-500', bgClass: 'bg-amber-50 dark:bg-amber-500/10' };
            case 'promo': return { icon: <MdCardGiftcard />, colorClass: 'text-brand-500', bgClass: 'bg-brand-50 dark:bg-brand-400/10' };
            case 'danger': return { icon: <MdCancel />, colorClass: 'text-red-500', bgClass: 'bg-red-50 dark:bg-red-500/10' };
            default: return { icon: <MdNotifications />, colorClass: 'text-gray-500', bgClass: 'bg-gray-100 dark:bg-navy-900' };
        }
    };

    // --- SAYFALAMA HESAPLARI ---
    const totalItems = notifications.length;
    const totalPages = Math.max(1, Math.ceil(totalItems / PAGE_SIZE));
    const paginatedNotifications = notifications.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);

    const handlePageChange = (page) => {
        if (page < 1 || page > totalPages) return;
        setCurrentPage(page);
    };

    // --- RENDER ---
    return (
        <div className="mt-5 flex w-full flex-col gap-6 pb-20 animate-fadeIn">

            {/* 1. ÜST BAŞLIK ALANI */}
            <div className="flex flex-col md:flex-row items-center justify-between gap-4 bg-white p-6 rounded-[20px] shadow-3xl shadow-shadow-500 dark:bg-navy-800 dark:shadow-none border border-gray-100 dark:border-white/10">
                <div className="flex items-center gap-4 w-full md:w-auto">
                    <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-yellow-400 to-orange-500 text-white shadow-lg flex-none">
                        <MdNotifications className="text-3xl" />
                    </div>
                    <div>
                        <h4 className="text-xl font-bold text-navy-700 dark:text-white">Bildirimlerim</h4>
                        <p className="text-sm font-medium text-gray-500 dark:text-gray-400">
                            Tüm önemli güncellemeleriniz ve randevu hatırlatmalarınız.
                        </p>
                    </div>
                </div>
            </div>

            {/* 2. BİLDİRİMLER LİSTESİ */}
            <div className="bg-white dark:bg-navy-800 rounded-[20px] shadow-sm border border-gray-100 dark:border-white/10 overflow-hidden">

                {loading ? (
                    <div className="p-6">
                        <NotificationsSkeleton />
                    </div>
                ) : notifications.length === 0 ? (
                    <div className="flex flex-col items-center justify-center py-20 opacity-60">
                        <MdNotifications className="text-7xl text-gray-300 dark:text-gray-600 mb-4" />
                        <h5 className="text-xl font-bold text-navy-700 dark:text-white">Yeni Bildirim Yok</h5>
                        <p className="text-sm font-medium text-gray-500 mt-2 text-center max-w-sm">
                            Randevu aldığınızda veya sistemde bir değişiklik olduğunda size buradan haber vereceğiz.
                        </p>
                    </div>
                ) : (
                    <div className="flex flex-col">
                        {paginatedNotifications.map((notif, index) => {
                            const { icon, colorClass, bgClass } = getNotificationIcon(notif.type);
                            const isLast = index === paginatedNotifications.length - 1;

                            const content = (
                                <div className={`flex items-center gap-4 p-5 transition-colors hover:bg-gray-50 dark:hover:bg-navy-900/50 ${!isLast ? 'border-b border-gray-100 dark:border-white/5' : ''}`}>
                                    {/* İkon */}
                                    <div className={`flex h-12 w-12 flex-none items-center justify-center rounded-full ${bgClass} ${colorClass} text-2xl shadow-sm`}>
                                        {icon}
                                    </div>
                                    {/* Metin */}
                                    <div className="flex-1">
                                        <p className="text-sm font-bold text-navy-700 dark:text-white leading-snug">
                                            {notif.text}
                                        </p>
                                    </div>
                                    {/* Link İkonu (varsa) */}
                                    {notif.link && (
                                        <div className="flex-none text-gray-400 group-hover:text-brand-500 transition-colors pl-2">
                                            <MdKeyboardArrowRight className="text-2xl" />
                                        </div>
                                    )}
                                </div>
                            );

                            return notif.link ? (
                                <Link key={notif.id} to={notif.link} className="group block">
                                    {content}
                                </Link>
                            ) : (
                                <div key={notif.id} className="block">
                                    {content}
                                </div>
                            );
                        })}
                    </div>
                )}

                {/* 3. SAYFALAMA (PAGINATION) */}
                {!loading && totalPages > 1 && (
                    <div className="flex items-center justify-between p-6 border-t border-gray-100 dark:border-white/10 bg-gray-50/50 dark:bg-navy-900/20">
            <span className="text-sm font-medium text-gray-500 dark:text-gray-400">
              Sayfa <span className="font-bold text-navy-700 dark:text-white">{currentPage}</span> / {totalPages}
            </span>

                        <div className="flex items-center gap-1">
                            {/* Önceki Butonu */}
                            <button
                                disabled={currentPage === 1}
                                onClick={() => handlePageChange(currentPage - 1)}
                                className="flex h-9 w-9 items-center justify-center rounded-lg border border-gray-200 bg-white text-gray-500 disabled:opacity-40 hover:bg-gray-50 dark:border-white/10 dark:bg-navy-800 dark:hover:bg-navy-700 transition-all mr-1"
                            >
                                <MdKeyboardArrowLeft className="text-xl" />
                            </button>

                            {/* Gelişmiş Sayfa Numaraları */}
                            {Array.from({ length: totalPages }, (_, i) => i + 1)
                                .filter((p) => p === 1 || p === totalPages || Math.abs(p - currentPage) <= 1)
                                .reduce((acc, p, idx, arr) => {
                                    if (idx === 0) return [p];
                                    if (p - arr[idx - 1] > 1) acc.push(-1);
                                    acc.push(p);
                                    return acc;
                                }, [])
                                .map((p, idx) =>
                                    p === -1 ? (
                                        <span key={`sep-${idx}`} className="px-2 text-gray-400 font-bold">...</span>
                                    ) : (
                                        <button
                                            key={p}
                                            onClick={() => handlePageChange(p)}
                                            className={`flex h-9 w-9 items-center justify-center rounded-lg text-sm font-bold transition-all ${
                                                p === currentPage
                                                    ? 'bg-brand-500 text-white shadow-md'
                                                    : 'bg-transparent text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-navy-700'
                                            }`}
                                        >
                                            {p}
                                        </button>
                                    )
                                )
                            }

                            {/* Sonraki Butonu */}
                            <button
                                disabled={currentPage === totalPages}
                                onClick={() => handlePageChange(currentPage + 1)}
                                className="flex h-9 w-9 items-center justify-center rounded-lg border border-gray-200 bg-white text-gray-500 disabled:opacity-40 hover:bg-gray-50 dark:border-white/10 dark:bg-navy-800 dark:hover:bg-navy-700 transition-all ml-1"
                            >
                                <MdKeyboardArrowRight className="text-xl" />
                            </button>
                        </div>
                    </div>
                )}

            </div>
        </div>
    );
};

export default CustomerNotifications;